import {
  HANGYIN_COMMODITY,
  HUXIAO_COMMODITY,
  WEIBO_COMMODITY,
  XIAOMI_COMMODITY,
  YINHE_COMMODITY,
  YXH_COMMODITY,
} from '@/shared/commodity';
// 我的-设置-法律协议隐私-合作渠道展示授信协议-需要展示本地授信协议渠道
export const isNeedTakeLocalFiles = (commodityId: string): boolean => [
  HANGYIN_COMMODITY,
  XIAOMI_COMMODITY,
  HUXIAO_COMMODITY,
  WEIBO_COMMODITY,
  YINHE_COMMODITY,
  YXH_COMMODITY,
  // NEW_YINHE_COMMODITY,
  // ALIPAYMINI_COMMODITY, 银河渠道，授信协议走后端接口返回
].indexOf(commodityId) >= 0;
